import React from 'react';
import Humanize from 'humanize-plus';
import { ChartCellFull, ChartCellWrapper, Text, ChartBg } from './sharedStyles';
import { getColumnBorderFlags } from './columnBorderFlags';

export const PosNegPercentRendererBG =
  (
    dataColors: any,
    firstColumnIds: Set<string>,
    lastColumnIds: Set<string>,
    columnIds: string[],
    hasScroll: boolean | undefined,
    dataMidPoints: number[] | undefined,
  ) =>
  // eslint-disable-next-line react/display-name
  ({ dataKey, rowData, cellData, columnIndex }: any) => {
    const columnIdx = typeof columnIndex === 'number' ? columnIndex : 0;
    const midPoint = dataMidPoints?.[columnIdx] || 0;
    const colors = rowData[`${dataKey}Color`] || dataColors;
    const opacity =
      cellData === midPoint || cellData === '-'
        ? 0
        : cellData > midPoint
          ? ((cellData - midPoint) / ((rowData[`${dataKey}Max`] - midPoint) / 70) / 100) * 0.4 + 0.3
          : ((cellData - midPoint) / ((rowData[`${dataKey}Min`] - midPoint) / 110) / 100) * 0.4 + 0.3;
    const { isFirst, isLast } = getColumnBorderFlags(columnIds, columnIndex, firstColumnIds, lastColumnIds, hasScroll);

    return (
      <ChartCellFull $isfirst={isFirst ? 1 : 0} $islast={isLast ? 1 : 0}>
        <ChartBg
          $background={
            Number(Humanize.toFixed(cellData, 2)) < midPoint
              ? colors[0]
              : Number(Humanize.toFixed(cellData, 2)) > midPoint
                ? colors[1]
                : '#fff'
          }
          $opacity={opacity}
        />
        <ChartCellWrapper>
          <Text>{Number(isNaN(cellData)) ? '-' : `${Humanize.toFixed(cellData, 2).replace('.00', '')}%`}</Text>
        </ChartCellWrapper>
      </ChartCellFull>
    );
  };
